var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { chunk } from "lodash";
import { Row, Col } from "react-bootstrap";
import { connect } from "@irati/store";
import { TextButton } from "@irati/ui/src/Button";
import padding from "@irati/ui/src/global/padding";
import { threePxElevation } from "@irati/ui/src/global/elevation";
import { Hr } from "@irati/ui/src/Layout";
import { Label2 } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { InspirationTile } from "./";
var StyledHr = styled(Hr)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 0px;\n"], ["\n  margin-top: 0px;\n"])));
var StyledCol = styled(Col)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.base);
var StyledTextButton = styled(TextButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transition: transform .24s, box-shadow .24s;\n  :hover {\n    ", ";\n    border: none;\n    cursor: pointer;\n    transform: translateY(-4px);\n  }\n"], ["\n  transition: transform .24s, box-shadow .24s;\n  :hover {\n    ", ";\n    border: none;\n    cursor: pointer;\n    transform: translateY(-4px);\n  }\n"])), threePxElevation);
var InspirationTiles = /** @class */ (function (_super) {
    __extends(InspirationTiles, _super);
    function InspirationTiles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderList = function (inspirations) {
            var _a = _this.props, isMobile = _a.isMobile, onClick = _a.onClick;
            var chunkSize = isMobile ? 1 : 2;
            return (chunk(inspirations, chunkSize).map(function (sub, i) {
                return React.createElement(Row, { key: i },
                    React.createElement(React.Fragment, null, sub.map(function (inspiration) {
                        return React.createElement(StyledCol, { key: inspiration.id, xs: 12, sm: 6 },
                            React.createElement(InspirationTile, { inspiration: inspiration, onClick: onClick, StyledTextButton: StyledTextButton, id: inspiration.id }));
                    })));
            }));
        };
        return _this;
    }
    InspirationTiles.prototype.render = function () {
        var tenant = authentication.userTenant();
        var inspirations = this.props.inspirations;
        var companyValues = inspirations.filter(function (i) { return i.isCompanyValue; });
        var defaultInspirations = inspirations.filter(function (i) { return !i.isCompanyValue; });
        var hasCompanyValues = !!companyValues.length;
        return (React.createElement(React.Fragment, null,
            hasCompanyValues &&
                React.createElement(React.Fragment, null,
                    React.createElement(Label2, { uppercase: true },
                        React.createElement(FormattedMessage, { id: "recognition.popup.createPoll.inspire.values", values: { tenantName: tenant.public_name } })),
                    this.renderList(companyValues),
                    React.createElement(StyledHr, null)),
            React.createElement(React.Fragment, null,
                React.createElement(Label2, { uppercase: true },
                    React.createElement(FormattedMessage, { id: "recognition.popup.createPoll.inspire.suggested" })),
                this.renderList(defaultInspirations))));
    };
    InspirationTiles.defaultProps = {
        className: null
    };
    return InspirationTiles;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: mq.lessThan.sm
    };
};
export default connect(mapStateToProps)(InspirationTiles);
var templateObject_1, templateObject_2, templateObject_3;
